/**
 * The one name of each Vello web console (owner D845 Q5, 2026-10-30): the same words in the page title, the sign-in
 * heading, the shell brand, the manual and every notice. A name is a proper noun, so it is not translated: it reads the
 * same in every language. Apps import it from here instead of typing the name again.
 */
export const CONSOLE_NAMES = {
    /** The platform operator console (the team that configures markets, rules and money). */
    admin: 'Vello Admin',
    /** The store console (orders, menu and payouts of a Food store). */
    merchant: 'Vello Loja',
    /** The fleet console (vehicles, drivers and payouts of a company). */
    fleet: 'Vello Frota',
    /** The partner desk (PDV: the hotel or company counter that requests rides). */
    desk: 'Vello Balcão',
    /** The support desk (agents handling the Central's cases). */
    central: 'Vello Central',
};
//# sourceMappingURL=console-names.js.map